import React from 'react';
import PropTypes from 'prop-types';

/**
 * ModalCardBody - A wrapper that renders a standard HTML div with Bulma class names
 *
 * This component accepts the same props as Bloomer ModalCardBody for easy migration
 */
const ModalCardBody = ({ className = '', children = null, style = {}, hasTextAlign = null, isPaddingless = false, tag: Tag = 'section', ...props }) => {
  // Build the class names based on props
  const getClassNames = () => {
    const classes = ['modal-card-body'];

    // Add custom class names
    if (className) {
      classes.push(className);
    }

    return classes.join(' ');
  };

  // Strip custom props before passing to DOM
  const { hasTextAlign: _hta, isPaddingless: _ip, ...domProps } = props;

  return (
    <Tag className={getClassNames()} style={style} {...domProps}>
      {children}
    </Tag>
  );
};

// eslint-disable-next-line react/require-default-props
ModalCardBody.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
};



export default ModalCardBody;
